function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.375 0C3.58211 0 3.75 0.167893 3.75 0.375V1.5H8.25V0.375C8.25 0.167893 8.41789 0 8.625 0C8.83211 0 9 0.167893 9 0.375V1.5H10.875C11.4963 1.5 12 2.00368 12 2.625V10.875C12 11.4963 11.4963 12 10.875 12H1.125C0.50368 12 0 11.4963 0 10.875V2.625C0 2.00368 0.50368 1.5 1.125 1.5H3V0.375C3 0.167893 3.16789 0 3.375 0ZM3 2.25H1.125C0.917893 2.25 0.75 2.41789 0.75 2.625V4.5H11.25V2.625C11.25 2.41789 11.0821 2.25 10.875 2.25H9V3C9 3.20711 8.83211 3.375 8.625 3.375C8.41789 3.375 8.25 3.20711 8.25 3V2.25H3.75V3C3.75 3.20711 3.58211 3.375 3.375 3.375C3.16789 3.375 3 3.20711 3 3V2.25ZM11.25 5.25H0.75V10.875C0.75 11.0821 0.917893 11.25 1.125 11.25H10.875C11.0821 11.25 11.25 11.0821 11.25 10.875V5.25Z",
  fill: "#0A0806"
});

const SvgCalendar = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.d61694c8.svg";
export { ForwardRef as ReactComponent };